module.exports = "/images/london-21.jpg";